<ng-template let-htmlContent="htmlContent">
    <div [outerHTML]="htmlContent | safeHtml"></div>
</ng-template>
